import { useState } from "react";
import {
  Avatar,
  Box,
  ButtonBase,
  CardMedia,
  Collapse,
  Grid,
  //IconButton,
  Typography,
  useTheme,
} from "@mui/material";

//import buttonImageUrl from "@/assets/icons/play.svg";
import { quickTourTabs } from "@/utils/staticData/homeData";
import Section from "@/components/Section";
import {
  getTabTitleStyles,
  //iconButtonStyles,
  imageStyles,
  imageWrapperStyles,
  //playIconStyles,
} from "./styles";

const QuickTour = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);

  const toggleActiveTab = (index: number) => {
    setActiveTab(index);
  };

  return (
    <Section
      pt={{ xs: 5, md: 12.5, lg: 17.5 }}
      pb={{ xs: 7.5, md: 12.5, lg: 17.5 }}
    >
      <Grid container spacing={{ xs: 5, lg: 7, xl: 10 }}>
        <Grid item xs={12} md={6} lg={5}>
          <Box
            height="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
          >
            <Typography variant="h2" color="text.primary" mb={2}>
              Book a Live Demo
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              mb={{ xs: 5, xl: 10 }}
            >
              The best way to experience Trackmate is to see it in action. Book a live demo to discover how it performs on your vehicles.
            </Typography>

            {/* Tab Content */}
            {quickTourTabs.map((card, index) => (
              <Box
                key={index}
                sx={getTabTitleStyles(theme, activeTab === index, index === 0)}
              >
                <ButtonBase
                  onClick={() => toggleActiveTab(index)}
                  sx={{ width: "100%", justifyContent: "start" }}
                >
                  <Box display="flex" gap={2} alignItems="center">
                    <Avatar src={card.iconUrl} sx={{ width: 32, height: 32 }} />
                    <Typography
                      variant="h6"
                      fontSize={{ md: "1.25rem" }}
                      sx={{ transform: "translateY(2px)" }}
                    >
                      {card.title}
                    </Typography>
                  </Box>
                </ButtonBase>

                <Collapse in={activeTab === index}>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    sx={{ pl: 6, mt: 1 }}
                  >
                    {card.description}
                  </Typography>
                </Collapse>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Tab image */}
        <Grid item xs={12} md={6} lg={7}>
          {quickTourTabs.map((card, index) => (
            <Collapse key={index} in={activeTab === index}>
              <Box sx={imageWrapperStyles}>
                {/* <IconButton sx={iconButtonStyles}>
                  <Avatar src={buttonImageUrl} sx={playIconStyles} />
                </IconButton> */}
                <CardMedia
                  component="img"
                  loading="lazy"
                  image={card.imageUrl}
                  alt="image"
                  sx={imageStyles}
                />
              </Box>
            </Collapse>
          ))}
        </Grid>
      </Grid>
    </Section>
  );
};

export default QuickTour;
